module.exports = __webpack_public_path__ + "img/arrow-double-up.1e8d42b2.png";